const $typesSelect = document.querySelectorAll('[data-type-code]');
const $stateChoose = document.querySelectorAll('[data-state]');

$stateChoose.forEach(($el) => $el.addEventListener('click', (event) => {
	const $target = event.currentTarget as HTMLElement;

	event.preventDefault();

	$stateChoose.forEach(($_el) => $_el.classList.remove('_active'));
	$el.classList.add('_active');
	document.body.classList.toggle('max-sun-protection', $target.dataset.state === 'max');

	const onclick = Function($target.dataset.onclick);
	if (event.isTrusted) onclick();

	window.location.hash = $target.dataset.hash;

	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});

	$typesSelect.forEach(($_el) => $_el.classList.remove('_active'));
	$typesSelect[0].classList.add('_active');
}));
